// extracted by mini-css-extract-plugin
export default {"labelsWrappers":"GiftRegistryLabelsEdit_labelsWrappers__kthUj"};